<template>
  <div class="dashboard frame-wrapper">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>ダッシュボード</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="list-container">
      <div id="chart-layout">
        <div class="list-area">
          <div class="list-area-title">
            <p class="ic-done">作業ログ</p>
          </div>
          <template v-if="logList && logList.length > 0">
            <table class="stripe">
              <tr
                v-for="(row, index) in logList"
                :key="index"
                class="tr-datas"
                :class="{
                  deleted: row.type === 3,
                }"
                @click="showRefLogFrame(index)"
              >
                <td class="tx-date">
                  {{ formatDatetime(row.work_date, "MM/DD") }}
                </td>
                <td class="tx-name-work">{{ row.worker }}</td>
                <!-- <td class="tx-item">{{ row.item_name }}</td> -->
                <td class="tx-item" v-if="row.type === 3">
                  [削除]&nbsp;{{ row.item_name }}
                </td>
                <td class="tx-item" v-else>{{ row.item_name }}</td>
                <td class="tx-paddyfield">
                  {{ getDisplayPaddyFieldNames(row.paddy_fields) }}
                </td>
                <td v-if="row.area_total" class="tx-area">
                  {{ row.area_total }}(a)
                </td>
                <td v-else class="tx-area"></td>
                <td v-if="isImages(row)" class="tx-images">
                  <div class="ic-images" />
                </td>
                <td v-else class="tx-images"></td>
              </tr>
            </table>
            <ul class="pagination" v-if="pagingLog.pageNoMax > 1">
              <li class="first">
                <a href="#" @click="pagingLogsFirst"><span>first</span></a>
              </li>
              <li class="previous">
                <a href="#" @click="pagingLogsPrevious"
                  ><span>previous</span></a
                >
              </li>
              <li
                v-for="index in pagingLog.pageNoMax"
                :key="index"
                :class="{ current: isLogCurrent(index) }"
              >
                <a href="#" @click="pagingLogsNo(index)">{{ index }}</a>
              </li>
              <li class="next">
                <a href="#" @click="pagingLogsNext"><span>next</span></a>
              </li>
              <li class="last">
                <a href="#" @click="pagingLogsLast"><span>last</span></a>
              </li>
            </ul>
          </template>
          <template v-else>
            <table class="stripe">
              <tr>
                <td class="tx-nothing">作業ログはありません</td>
              </tr>
            </table>
          </template>
        </div>
        <div class="list-area">
          <div class="list-area-title">
            <p class="ic-done">作業進捗</p>
          </div>
          <table class="stripe">
            <template v-if="workItemList && workItemList.length > 0">
              <tr v-for="(row, index) in workItemList" :key="index" 
              class="tr-datas" 
              :class="{ disabled: isReadOnly }"
              @click="onClickWorkItem(index)">
                <td style="width: 20%; max-width:300px">{{ row.season.season_name }}</td>
                <td style="width: 20%; max-width:300px">{{ row.item_name }}</td>
                <td style="width: 40%">
                  <div class="work-progress-layout">
                    <span class="area-value"
                      >{{ row.actual_total_area }} /
                      {{ row.item_area_total }} (a)</span
                    >
                    <span class="progress-bar-outer">
                      <span
                        :style="{
                          width: row.actual_percent + '%',
                          background: row.season.color,
                          borderRadius: '30px',
                        }"
                      ></span>
                    </span>
                  </div>
                </td>
                <td style="width: 10%; text-align: center">
                  {{ row.actual_percent }}%
                </td>
              </tr>
              <tr v-if="workItemList.length < masterWorkProgress.length">
                <td colspan="4" class="list-message" @click="onClickAllItem">
                  <span> すべてを見る </span>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td class="tx-nothing">表示する進捗はありません</td>
              </tr>
            </template>
          </table>
        </div>
        <div class="list-area">
          <div class="list-area-title">
            <p class="ic-info">お知らせ</p>
            <div id="button-area">
              <span
                class="btn-submit"
                :class="{ disable: isReadOnly }"
                @click="showAddFrame"
                >投稿</span
              >
            </div>
          </div>
          <template v-if="informationList && informationList.length > 0">
            <table class="stripe">
              <tr
                v-for="(row, index) in informationList"
                :key="index"
                class="tr-datas"
                @click="showRefFrame(index)"
              >
                <td class="tx-datetime">{{ formatDatetime(row.datetime) }}</td>
                <td class="tx-name">{{ row.contributor }}</td>
                <td class="tx-content">{{ row.title }}</td>
                <td v-if="isImages(row)" class="tx-images">
                  <div class="ic-images" />
                </td>
                <td v-else class="tx-images"></td>
              </tr>
            </table>
            <ul class="pagination" v-if="pagingInformation.pageNoMax > 1">
              <li class="first">
                <a href="#" @click="pagingInformationsFirst"
                  ><span>first</span></a
                >
              </li>
              <li class="previous">
                <a href="#" @click="pagingInformationsPrevious"
                  ><span>previous</span></a
                >
              </li>
              <li
                v-for="index in pagingInformation.pageNoMax"
                :key="index"
                :class="{ current: isInformationCurrent(index) }"
              >
                <a href="#" @click="pagingInformationsNo(index)">{{ index }}</a>
              </li>
              <li class="next">
                <a href="#" @click="pagingInformationsNext"
                  ><span>next</span></a
                >
              </li>
              <li class="last">
                <a href="#" @click="pagingInformationsLast"
                  ><span>last</span></a
                >
              </li>
            </ul>
          </template>
          <template v-else>
            <table class="stripe">
              <tr>
                <td class="tx-nothing">お知らせはありません</td>
              </tr>
            </table>
          </template>
        </div>
        <div class="list-area">
          <div class="list-area-title">
            <p class="ic-water-gate">水門ログ</p>
          </div>
          <template v-if="waterGateList && waterGateList.length > 0">
            <table class="stripe">
              <tr
                v-for="(row, index) in waterGateList"
                :key="index"
                class="tr-datas disabled"
              >
                <td class="tx-gate-type">{{ getWaterGateTypeName(row.gate_type) }}</td>
                <td class="tx-gate-status full-open" v-if="isWaterGateFull(row.gate_status)">{{ getWaterGateStatusName(row.gate_status) }}</td>
                <td class="tx-gate-status half-open" v-else-if="isWaterGateHalf(row.gate_status)">{{ getWaterGateStatusName(row.gate_status) }}</td>
                <td class="tx-gate-status" v-else>{{ getWaterGateStatusName(row.gate_status) }}</td>
                <td class="tx-gate-date" >{{ formatDatetime(row.datetime) }}</td>
                <td class="tx-gate-ope" >{{ row.worker }}</td>
                <td class="tx-gate-name">{{ row.paddy_field_name }}</td>
              </tr>
            </table>
            <ul class="pagination" v-if="pagingWaterGate.pageNoMax > 1">
              <li class="first">
                <a href="#" @click="pagingWaterGatesFirst"
                  ><span>first</span></a
                >
              </li>
              <li class="previous">
                <a href="#" @click="pagingWaterGatesPrevious"
                  ><span>previous</span></a
                >
              </li>
              <li
                v-for="index in pagingWaterGate.pageNoMax"
                :key="index"
                :class="{ current: isWaterGateCurrent(index) }"
              >
                <a href="#" @click="pagingWaterGatesNo(index)">{{ index }}</a>
              </li>
              <li class="next">
                <a href="#" @click="pagingWaterGatesNext"
                  ><span>next</span></a
                >
              </li>
              <li class="last">
                <a href="#" @click="pagingWaterGatesLast"
                  ><span>last</span></a
                >
              </li>
            </ul>
          </template>
          <template v-else>
            <table class="stripe">
              <tr>
                <td class="tx-nothing">水門ログはありません。</td>
              </tr>
            </table>
          </template>
        </div>
      </div>
    </div>
    <Weather />
    <div class="list-container" v-if="isWater">
      <div id="chart-layout">
        <div class="list-area">
          <div class="list-area-title">
            <p class="ic-water">水位センサー</p>
          </div>
          <template v-if="sensorList && sensorList.length > 0">
            <table class="stripe">
              <tr
                v-for="(row, index) in sensorList"
                :key="index"
                class="tr-datas"
                :class="{
                  active: !isReadOnly,
                  disabled: isReadOnly,
                }"
                @click="showRefSensorFrame(index)"
              >
                <td class="tx-sensor-type err" v-if="row.status == '9'">未連係</td>
                <td class="tx-sensor-type warn" v-else-if="row.status == '1'">警告水位</td>
                <td class="tx-sensor-type caution" v-else-if="row.status == '2'">危険水位</td>
                <td class="tx-sensor-type normal" v-else>正常</td>
                <td class="tx-date" v-if="row.data && row.data.length > 0">{{ row.data[0].water_level }} cm</td>
                <td class="tx-date" v-else>-</td>
                <td class="tx-date">{{ row.sensor_id }}</td>
                <td class="tx-sensor-item">{{ row.sensor_name }}</td>
              </tr>
            </table>
            <ul class="pagination" v-if="pagingSensor.pageNoMax > 1">
              <li class="first">
                <a href="#" @click="pagingSensorFirst"><span>first</span></a>
              </li>
              <li class="previous">
                <a href="#" @click="pagingSensorPrevious"
                  ><span>previous</span></a
                >
              </li>
              <li
                v-for="index in pagingSensor.pageNoMax"
                :key="index"
                :class="{ current: isSensorCurrent(index) }"
              >
                <a href="#" @click="pagingSensorNo(index)">{{ index }}</a>
              </li>
              <li class="next">
                <a href="#" @click="pagingSensorNext"><span>next</span></a>
              </li>
              <li class="last">
                <a href="#" @click="pagingSensorLast"><span>last</span></a>
              </li>
            </ul>
          </template>
          <template v-else>
            <table class="stripe">
              <tr>
                <td class="tx-nothing">水位センサーの設置はありません</td>
              </tr>
            </table>
          </template>
        </div>
        <div class="list-area">
          <div class="list-area-title">
            <p class="ic-alert">水位アラート</p>
          </div>
          <template v-if="alertList && alertList.length > 0">
            <table class="stripe">
              <tr
                v-for="(row, index) in alertList"
                :key="index"
                class="tr-nodatas"
              >
                <td class="tx-date">{{ formatDatetime(row.datetime, 'MM/DD HH:mm') }}</td>
                <td class="tx-sensor-item">{{ row.message }}</td>
              </tr>
            </table>
            <ul class="pagination" v-if="pagingAlert.pageNoMax > 1">
              <li class="first">
                <a href="#" @click="pagingAlertFirst"><span>first</span></a>
              </li>
              <li class="previous">
                <a href="#" @click="pagingAlertPrevious"
                  ><span>previous</span></a
                >
              </li>
              <li
                v-for="index in pagingAlert.pageNoMax"
                :key="index"
                :class="{ current: isAlertCurrent(index) }"
              >
                <a href="#" @click="pagingAlertNo(index)">{{ index }}</a>
              </li>
              <li class="next">
                <a href="#" @click="pagingAlertNext"><span>next</span></a>
              </li>
              <li class="last">
                <a href="#" @click="pagingAlertLast"><span>last</span></a>
              </li>
            </ul>
          </template>
          <template v-else>
            <table class="stripe">
              <tr>
                <td class="tx-nothing">水位アラートはありません</td>
              </tr>
            </table>
          </template>
        </div>
        <div style="margin-top:2rem"></div>
      </div>
    </div>
    <div
      v-if="showCenterFrame"
      class="center-frame-container"
    >
      <transition name="scale" appear>
        <template v-if="isCenterFrameAdd || isCenterFrameEdit">
          <div class="center-frame">
            <div class="title-area">
              <h3>お知らせ</h3>
              <div class="btn-close" @click="hideCenterFrame"></div>
            </div>
            <validation-observer ref="obs" v-slot="ObserverProps">
              <section class="section">
                <div class="container">
                  <div class="contents-body">
                    <dl class="columns">
                      <dt>投稿者</dt>
                      <dd>{{ userInfo.name }}</dd>
                      <dt>タイトル</dt>
                      <dd>
                        <ValidationProvider
                          rules="required|max:100"
                          v-slot="ProviderProps"
                        >
                          <input type="text" v-model="informationInfo.title" />
                          <div class="validation-error">
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                      </dd>
                      <dt>内容</dt>
                      <dd>
                        <ValidationProvider
                          rules="max:1000"
                          v-slot="ProviderProps"
                        >
                          <textarea v-model="informationInfo.contents" />
                          <div class="validation-error">
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                      </dd>
                      <dt>
                        <div id="upload-area">
                          <label class="active">
                            <input
                              type="file"
                              ref="preview"
                              accept="image/png, image/jpeg"
                              @change="readFile"
                              multiple
                            />画像アップロード
                          </label>
                        </div>
                      </dt>
                      <dd>
                        <div class="upload-area-view">
                          <template v-for="(row, index) in fileList">
                            <div :key="index">
                              <span class="active" @click="deletePreview(index)">
                              </span>
                              <template v-if="row.data">
                                <img :src="row.data" />
                              </template>
                              <template v-else>
                                <img :src="row.url" />
                              </template>
                            </div>
                          </template>
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </section>
              <div id="button-area">
                <div class="left-box" />
                <div class="center-box">
                  <template v-if="isCenterFrameAdd">
                    <span
                      class="btn btn-submit"
                      :class="{ disable: ObserverProps.invalid }"
                      @click="onSubmit"
                      >投稿</span
                    >
                  </template>
                  <template v-else>
                    <span
                      class="btn btn-submit"
                      :class="{ disable: ObserverProps.invalid }"
                      @click="onSubmit"
                      >保存</span
                    >
                  </template>
                  <span class="btn btn-cancel" @click="onCancel"
                    >キャンセル</span
                  >
                </div>
                <div class="right-box">
                  <template v-if="userInfo.id === informationInfo.user_id">
                    <span
                      class="text"
                      :class="{
                        active: !isReadOnly,
                        disabled: isReadOnly,
                      }"
                      @click="onDelete"
                      >削除</span
                    >
                  </template>
                  <template v-else>
                    <span class="text disabled" @click="onDelete">削除</span>
                  </template>
                </div>
              </div>
            </validation-observer>
          </div>
        </template>
        <template v-else-if="isCenterFrameRef">
          <div class="center-frame">
            <div class="title-area">
              <h3>{{ informationInfo.title }}</h3>
              <div class="btn-close" @click="hideCenterFrame"></div>
            </div>
            <div id="edit-area">
              <template v-if="userInfo.id === informationInfo.user_id">
                <span
                  :class="{
                    active: !isReadOnly,
                    disabled: isReadOnly,
                  }"
                  @click="showEditFrame"
                  >編集する</span
                >
              </template>
              <template v-else>
                <span class="disabled">編集する</span>
              </template>
            </div>
            <section class="section">
              <div class="container">
                <div class="contents-body">
                  <span class="textarea">{{ informationInfo.contents }}</span>
                </div>
                <div class="contents-footer">
                  <span
                    >{{
                      formatDatetime(
                        informationInfo.datetime,
                        "YYYY/MM/DD HH:mm:ss"
                      )
                    }}
                    &nbsp; {{ informationInfo.contributor }}</span
                  >
                  <div class="image-area-view">
                    <template v-for="(row, index) in informationInfo.image_urls">
                      <div :key="index">
                        <img :src="row" />
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </section>
            <div id="button-area">
              <div class="left-box" />
              <div class="center-box"></div>
              <div class="right-box">
                <!-- <template v-if="userInfo.id === informationInfo.user_id">
                  <span
                    class="text"
                    :class="{
                      active: !isReadOnly,
                      disabled: isReadOnly,
                    }"
                    @click="onDelete"
                    >削除</span
                  >
                </template>
                <template v-else>
                  <span class="text disabled" @click="onDelete">削除</span>
                </template> -->
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isCenterFrameRefLog">
          <div class="center-frame">
            <div class="title-area">
              <h3>作業ログ</h3>
              <div class="btn-close" @click="hideCenterFrame"></div>
            </div>
            <section class="section">
              <div class="container">
                <div class="contents-body">
                  <table>
                    <tr>
                      <td>
                        <span
                          >{{
                            formatDatetime(logInfo.work_date, "YYYY/MM/DD")
                          }}
                          &nbsp; {{ logInfo.worker }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span
                          >{{ logInfo.season_name }}／{{
                            logInfo.item_name
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr v-if="logInfo.area_total">
                      <td>
                        <span>{{ logInfo.area_total }}&nbsp;(a)</span>
                      </td>
                    </tr>
                  </table>
                  <div
                    class="detail-list-container"
                    v-if="
                      logInfo.paddy_fields && logInfo.paddy_fields.length > 0
                    "
                  >
                    <template v-if="logInfo.paddy_fields.length === 1">
                      <span>{{
                        logInfo.paddy_fields[0].paddy_field_name
                      }}</span>
                    </template>
                    <template v-else>
                      <table>
                        <tr
                          v-for="(row, index) in logInfo.paddy_fields"
                          :key="index"
                        >
                          <td class="tx-no">{{ index + 1 }}</td>
                          <td class="tx-name">{{ row.paddy_field_name }}</td>
                        </tr>
                      </table>
                    </template>
                  </div>
                  <div
                    class="detail-item-list-container"
                    v-if="
                      logInfo.item_details && logInfo.item_details.length > 0
                    "
                  >
                    <template v-for="(row, index) in logInfo.item_details">
                      <template v-if="row.item_detail_value != null">
                        <!-- <div :key="index" class="detail-item-field"> -->
                        <div :key="index">
                          <span v-if="row.item_detail_unit">
                            {{ row.item_detail_name }}({{
                              row.item_detail_unit
                            }})&ensp;{{ row.item_detail_value }}
                          </span>
                          <span v-else>
                            {{ row.item_detail_name }}&ensp;{{
                              row.item_detail_value
                            }}
                          </span>
                        </div>
                      </template>
                    </template>
                  </div>
                  <div class="image-area-view">
                    <template v-for="(row, index) in logInfo.image_urls">
                      <div :key="index">
                        <img :src="row" />
                      </div>
                    </template>
                  </div>
                </div>
                <div class="contents-footer"></div>
              </div>
            </section>
            <div id="button-area">
              <div class="left-box" />
              <div class="center-box" />
              <div class="right-box" v-if="logInfo.type === 3">
                <!-- <span class="text disabled">削除</span> -->
              </div>
              <div class="right-box" v-else>
                <template v-if="logInfo.del_flg === '1'">
                  <span class="text disabled">削除</span>
                </template>
                <template v-else>
                  <span
                    class="text"
                    :class="{
                      active: !isReadOnly,
                      disabled: isReadOnly,
                    }"
                    @click="onWorkLogDelete"
                    >削除</span
                  >
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isCenterFrameRefWater">
          <div class="center-frame water">
            <div class="title-area">
              <h3>{{ nowSensorName }}</h3>
              <div class="btn-close" @click="hideCenterFrame"></div>
            </div>
            <section class="section">
              <div class="container">
                <div class="contents-body">
          <div class="side-frame-content water">
            <div class="graph">
              <div class="graph-header">
                <span class="water01"></span>
                <h5>水位</h5>
                <p>{{ nowWaterLevel }}cm</p>
              </div>
              <LineChart
                class="graph-graph"
                v-if="loadedWater"
                :chartData="chartdataWater"
                :options="optionsWater"
              ></LineChart>
            </div>

            <div class="graph">
              <div class="graph-header">
                <span class="water02"></span>
                <h5>水温</h5>
                <p>{{ nowWaterTemp }}℃</p>
              </div>
              <LineChart
                class="graph-graph"
                v-if="loadedWaterTemp"
                :chartData="chartdataWaterTemp"
                :options="optionsWaterTemp"
              ></LineChart>
            </div>
          </div>
                </div>
                <div class="contents-footer"></div>
              </div>
            </section>
          </div>
        </template>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import Weather from "@/views/Weather.vue";
import Dialog from "@/mixins/dialog";
import { Storage } from "aws-amplify";
import Compression from "@/mixins/compression";
import LineChart from "@/components/WeatherChartLine.vue";
import Contract from "@/mixins/contract";

const PER_PAGE_INFO = 3;
const PER_PAGE = 8;
const CENTER_FRAME_STATUS = {
  HIDDEN: 0,
  ADD: 1,
  REFERENCE: 2,
  REFERENCE_LOG: 3,
  EDIT: 4,
  WATER: 5,
};
const WATER_GATE_TYPE = { SUPPLY: 1, OUT: 2 };
const WATER_GATE_STATUS = { CLOSED: "0", HALF: "1", FULL: "2" };

export default {
  components: { Weather, LineChart },
  mixins: [Loader, Dialog, Contract],

  data() {
    return {
      showCenterFrame: false,
      centerFrameStatus: CENTER_FRAME_STATUS.HIDDEN,
      informationList: null,
      informationInfo: null,
      pagingInformation: {
        totalCount: 0,
        pageNoMax: 0,
        pageNoCurrent: 1,
      },
      logList: null,
      logInfo: null,
      pagingLog: {
        totalCount: 0,
        pageNoMax: 0,
        pageNoCurrent: 1,
      },
      userInfo: {
        name: null,
        id: null,
      },
      isReadOnly: true,
      workItemList: null,
      masterWorkProgress: null,
      fileList: [],
      selectedInformationId: null,
      sensorList: null,
      sensorInfo: null,
      pagingSensor: {
        totalCount: 0,
        pageNoMax: 0,
        pageNoCurrent: 1,
      },
      waterGateList: [],
      pagingWaterGate: {
        totalCount: 0,
        pageNoMax: 0,
        pageNoCurrent: 1,
      },
      alertList: null,
      pagingAlert: {
        totalCount: 0,
        pageNoMax: 0,
        pageNoCurrent: 1,
      },
      loadedWater: false,
      chartdataWater: null,
      optionsWater: null,
      loadedWaterTemp: false,
      chartdataWaterTemp: null,
      optionsWaterTemp: null,
      sensorDatas: [],
      nowWaterLevel : null,
      nowWaterTemp : null,
      nowSensorName: null,
      isWater: false,
    };
  },

  computed: {
    anyInput() {
      return Object.keys(this.informationInfo).some((key) => {
        if (this.informationInfo[key]) {
          return true;
        }
      });
    },
    isCenterFrameHidden() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.HIDDEN;
    },

    isCenterFrameAdd() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.ADD;
    },

    isCenterFrameEdit() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.EDIT;
    },

    isCenterFrameRef() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.REFERENCE;
    },

    isCenterFrameRefLog() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.REFERENCE_LOG;
    },

    isCenterFrameRefWater() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.WATER;
    },

    isDeleteLog(logInfo) {
      return logInfo.type === 3;
    },
  },

  mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      await this.load();

      this.workItemList = [];
      this.workItemList = this.workItemList.concat(
        this.masterWorkProgress.slice(0, 5)
      );
    });
  },

  methods: {
    ...mapActions([
      "retrieveInformations",
      "insertInformations",
      "updateInformations",
      "updateReadInformation",
      "deleteInformations",
      "retrieveLogs",
      "showUserId",
      "showAccount",
      "showAccountID",
      "updateNowTemperature",
      "deleteLogs",
      "retrieveWorkProgress",
      "retrieveSensorsPaging",
      "retrieveSensorAlert",
      "retrieveSensorRawData",
      "retrieveSeasons",
      "retrieveWaterGateLogs"
    ]),
    ...mapGetters(["getDisplayName", "getUserId", "getAccountID", "isPastManagement", "getCurrentManagementId", "getSensorPaging"]),

    async load() {
      try {
        const acinfo = await this.showAccount(await this.showAccountID());
        this.isReadOnly = this.isAccountExpired(acinfo) || this.isPastManagement();
        this.isWater = this.isValidWater(acinfo);
      } catch (error) {
        console.log(error);
      }
      await this.searchInformations(1);
      await this.searchLogs(1);
      await this.searchAlert(1);
      await this.searchSensor(1);
      await this.searchWaterGates(1);

      // 作業進捗取得
      this.masterWorkProgress = await this.retrieveWorkProgress();
      // マスタも取得しておく
      await this.retrieveSeasons();

      this.userInfo.name = this.getDisplayName();
      await this.showUserId();
      this.userInfo.id = this.getUserId();
      await this.updateNowTemperature();
    },
    onCancel() {
      this.hideCenterFrame();
    },
    async onSubmit() {
      this.loading(async () => {
        try {
          const nowDatetime = this.formatDatetime(new Date(), "YYYYMMDDHHmmssSSS");
          let s3FileNames = [];

          const mngId = this.getCurrentManagementId();

          for (let i = 0; i < this.fileList.length; i++) {
            // 画像が追加されていたらアップロード
            if (this.fileList[i].file) {
              let ext = this.fileList[i].fileName.substr(
                this.fileList[i].fileName.lastIndexOf(".")
              );
              ext = ext.toLowerCase();
              if ([".jpg",".jpeg",".jpe",".jif",".jfif",".jfi"].includes(ext)) {
                ext = ".jpg";
              }
              const s3FileName =
                mngId + "/image/" + nowDatetime + "-info/" + (i + 1) + ext;
              s3FileNames.push(s3FileName);
              await Storage.put(s3FileName, this.fileList[i].file, {
                level: "public",
                contentType: this.fileList[i].type,
              });
            }
            else {
              s3FileNames.push(this.fileList[i].path);
            }
          }
          this.informationInfo.contributor = this.userInfo.name;
          this.informationInfo.user_id = this.userInfo.id;
          this.informationInfo.image_paths = s3FileNames;

          if (this.centerFrameStatus === CENTER_FRAME_STATUS.ADD) {
            await this.insertInformations(this.informationInfo);
          }
          else {
            await this.updateInformations(this.informationInfo);
          }

          await this.load();

          this.hideCenterFrame();
        } catch (error) {
          alert("通信エラー");
          console.log(error);
          throw error;
        }
      });
    },
    async onWorkLogDelete() {
      this.showConfirm("登録した作業実績を削除しますか？", async () => {
        this.loading(async () => {
          try {
            // 削除
            await this.deleteLogs({
              managementId: this.logInfo.management_id,
              logId: this.logInfo.log_id,
            });

            await this.load();

            this.hideCenterFrame();
          } catch (error) {
            alert("通信エラー");
            console.log(error);
            throw error;
          }
        });
      });
    },

    async onDelete() {
      this.showConfirm("削除しますか？", async () => {
        this.loading(async () => {
          try {
            // 削除
            await this.deleteInformations(this.informationInfo.information_id);

            await this.load();

            this.hideCenterFrame();
          } catch (error) {
            alert("通信エラー");
            console.log(error);
            throw error;
          }
        });
      });
    },

    async searchInformations(pageNo) {
      try {
        if (pageNo === 1) {
          // １ページ目選択時のみ、最大件数も保持する
          const result = await this.retrieveInformations({
            count: PER_PAGE_INFO,
          });
          this.informationList = result.list;
          this.pagingInformation.totalCount = result.total_count;
          this.pagingInformation.pageNoMax = Math.ceil(
            this.pagingInformation.totalCount / PER_PAGE_INFO
          );
          this.pagingInformation.pageNoCurrent = pageNo;
        } else {
          if (pageNo < this.pagingInformation.pageNoCurrent) {
            const result = await this.retrieveInformations({
              count: PER_PAGE_INFO,
              skip: pageNo - 1,
            });
            this.informationList = result.list;
            this.pagingInformation.pageNoCurrent = pageNo;
          } else {
            const result = await this.retrieveInformations({
              count: PER_PAGE_INFO,
              lastId:
                this.informationList[this.informationList.length - 1]
                  .information_id,
              skip: pageNo - this.pagingInformation.pageNoCurrent - 1,
            });
            this.informationList = result.list;
            this.pagingInformation.pageNoCurrent = pageNo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async searchLogs(pageNo) {
      try {
        if (pageNo === 1) {
          // １ページ目選択時のみ、最大件数も保持する
          const result = await this.retrieveLogs({ count: PER_PAGE });
          this.logList = result.list;
          this.pagingLog.totalCount = result.total_count;
          this.pagingLog.pageNoMax = Math.ceil(
            this.pagingLog.totalCount / PER_PAGE
          );
          this.pagingLog.pageNoCurrent = pageNo;
        } else {
          if (pageNo < this.pagingLog.pageNoCurrent) {
            const result = await this.retrieveLogs({
              count: PER_PAGE,
              skip: pageNo - 1,
            });
            this.logList = result.list;
            this.pagingLog.pageNoCurrent = pageNo;
          } else {
            const result = await this.retrieveLogs({
              count: PER_PAGE,
              lastId: this.logList[this.logList.length - 1].log_id,
              skip: pageNo - this.pagingLog.pageNoCurrent - 1,
            });
            this.logList = result.list;
            this.pagingLog.pageNoCurrent = pageNo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async searchAlert(pageNo) {
      try {
        if (pageNo === 1) {
          // １ページ目選択時のみ、最大件数も保持する
          const result = await this.retrieveSensorAlert({ count: PER_PAGE });
          this.alertList = result.list;
          this.pagingAlert.totalCount = result.total_count;
          this.pagingAlert.pageNoMax = Math.ceil(
            this.pagingAlert.totalCount / PER_PAGE
          );
          this.pagingAlert.pageNoCurrent = pageNo;
        } else {
          if (pageNo < this.pagingAlert.pageNoCurrent) {
            const result = await this.retrieveSensorAlert({
              count: PER_PAGE,
              skip: pageNo - 1,
            });
            this.alertList = result.list;
            this.pagingAlert.pageNoCurrent = pageNo;
          } else {
            const result = await this.retrieveSensorAlert({
              count: PER_PAGE,
              lastId: this.alertList[this.alertList.length - 1].alert_id,
              skip: pageNo - this.pagingAlert.pageNoCurrent - 1,
            });
            this.alertList = result.list;
            this.pagingAlert.pageNoCurrent = pageNo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async searchWaterGates(pageNo) {

      try {
        if (pageNo === 1) {
          // １ページ目選択時のみ、最大件数も保持する
          const result = await this.retrieveWaterGateLogs({
            count: PER_PAGE,
          });
          this.waterGateList = result.list;
          this.pagingWaterGate.totalCount = result.total_count;
          this.pagingWaterGate.pageNoMax = Math.ceil(
            this.pagingWaterGate.totalCount / PER_PAGE
          );
          this.pagingWaterGate.pageNoCurrent = pageNo;
        } else {
          if (pageNo < this.pagingWaterGate.pageNoCurrent) {
            const result = await this.retrieveWaterGateLogs({
              count: PER_PAGE,
              skip: pageNo - 1,
            });
            this.waterGateList = result.list;
            this.pagingWaterGate.pageNoCurrent = pageNo;
          } else {
            const result = await this.retrieveWaterGateLogs({
              count: PER_PAGE,
              lastId:
                this.waterGateList[this.waterGateList.length - 1].log_id,
              skip: pageNo - this.pagingWaterGate.pageNoCurrent - 1,
            });
            this.waterGateList = result.list;
            this.pagingWaterGate.pageNoCurrent = pageNo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async searchSensor(pageNo) {
      try {
        if (pageNo === 1) {
          // １ページ目選択時のみ、最大件数も保持する
          const result = await this.retrieveSensorsPaging();
          this.sensorList = result.slice(0, PER_PAGE);
          this.pagingSensor.totalCount = result.length;
          this.pagingSensor.pageNoMax = Math.ceil(
            this.pagingSensor.totalCount / PER_PAGE
          );
          this.pagingSensor.pageNoCurrent = pageNo;
        } else {
          const result = await this.getSensorPaging();
          const endIdx = (PER_PAGE * pageNo);
          const startIdx = endIdx - PER_PAGE;
          this.sensorList = result.slice(startIdx, endIdx);
          this.pagingSensor.pageNoCurrent = pageNo;
        }
      } catch (error) {
        console.log(error);
      }
    },
    showAddFrame() {
      this.informationInfo = {};
      this.fileList = [];
      this.showCenterFrame = true;
      this.centerFrameStatus = CENTER_FRAME_STATUS.ADD;
    },
    async showEditFrame() {
      this.informationInfo = {};
      this.fileList = [];
      this.informationInfo = this.informationList[this.selectedInformationId];
      this.informationInfo.image_urls = [];
      if (this.informationInfo.image_paths) {
        try {
          for (const path of this.informationInfo.image_paths) {
            const url = await Storage.get(path);
            const item = {
              path: path,
              url: url,
            };
            this.fileList.push(item);
          }
        } catch (err) {
          console.log(err);
        }
      }
      this.showCenterFrame = true;
      this.centerFrameStatus = CENTER_FRAME_STATUS.EDIT;
    },
    async showRefFrame(index) {
      this.informationInfo = this.informationList[index];
      this.informationInfo.image_urls = [];
      if (this.informationInfo.image_paths) {
        try {
          for (const path of this.informationInfo.image_paths) {
            const url = await Storage.get(path);
            this.informationInfo.image_urls.push(url);
          }
        } catch (err) {
          console.log(err);
        }
      }
      this.showCenterFrame = true;
      this.centerFrameStatus = CENTER_FRAME_STATUS.REFERENCE;
      this.selectedInformationId = index;
      // 閲覧済みにマーキング
      try {
        await this.updateReadInformation({
          user_id: this.userInfo.id,
          information_id: this.informationInfo.information_id,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async showRefLogFrame(index) {
      this.logInfo = this.logList[index];
      this.logInfo.image_urls = [];
      if (this.logInfo.image_paths) {
        try {
          for (const path of this.logInfo.image_paths) {
            const url = await Storage.get(path);
            this.logInfo.image_urls.push(url);
          }
        } catch (err) {
          console.log(err);
        }
      }
      this.showCenterFrame = true;
      this.centerFrameStatus = CENTER_FRAME_STATUS.REFERENCE_LOG;
    },
    async showRefSensorFrame(index) {
      /*
      this.sensorInfo = this.sensorList[index];
      this.nowSensorName = this.sensorInfo.sensor_id;
      console.log(this.sensorInfo);
      if (this.sensorInfo.sensor_name) {
        this.nowSensorName += "(" + this.sensorInfo.sensor_name + ")";
      }

      try {
        this.sensorDatas = [];
        let dt = new Date();
        // 3時間分のデータを取得する
        let todt =
          dt.getFullYear() +
          "-" +
          ("0" + (dt.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + dt.getDate()).slice(-2) +
          "T" +
          ("0" + dt.getHours()).slice(-2) +
          ":" +
          ("0" + dt.getMinutes()).slice(-2) +
          ":00+0900";

        dt.setHours(dt.getHours() - 3);
        let fromdt =
          dt.getFullYear() +
          "-" +
          ("0" + (dt.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + dt.getDate()).slice(-2) +
          "T" +
          ("0" + dt.getHours()).slice(-2) +
          ":" +
          ("0" + dt.getMinutes()).slice(-2) +
          ":00+0900";
        const ret = await this.retrieveSensorRawData({
          sensorId: this.sensorInfo.sensor_id,
          from: fromdt,
          to: todt,
        });
        if (ret && ret.data) {
          this.sensorDatas = ret.data;
        }
      } catch (error) {
        alert(error);
        throw error;
      }
      if (this.sensorDatas && this.sensorDatas.length > 0) {
        this.nowWaterLevel = this.sensorDatas[0].water_level;
        this.nowWaterTemp = this.sensorDatas[0].water_temperature;
      }
      else {
        this.nowWaterLevel = null;
        this.nowWaterTemp = null;
      }

      this.loadedWater = false;
      this.loadedWaterTemp = false;
      this.RenderChartWater();
      this.RenderChartWaterTemp();

      this.showCenterFrame = true;
      this.centerFrameStatus = CENTER_FRAME_STATUS.WATER;
      */

      // 水位マップに遷移
      this.sensorInfo = this.sensorList[index];
      this.$router.push({
        name: "water-show",
        params: { prmLat: this.sensorInfo.latitude, prmLng: this.sensorInfo.longitude },
      });
    },
    hideCenterFrame() {
      this.showCenterFrame = false;
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
    },

    formatDatetime(src, format = "MM/DD HH:mm") {
      if (!src) {
        return "";
      }
      let dest = format;
      const date = new Date(src);
      dest = dest.replace(/YYYY/, date.getFullYear());
      dest = dest.replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2));
      dest = dest.replace(/DD/, ("0" + date.getDate()).slice(-2));
      dest = dest.replace(/HH/, ("0" + date.getHours()).slice(-2));
      dest = dest.replace(/mm/, ("0" + date.getMinutes()).slice(-2));
      dest = dest.replace(/ss/, ("0" + date.getSeconds()).slice(-2));
      dest = dest.replace(/SSS/, ("0" + date.getMilliseconds()).slice(-3));
      return dest;
    },
    getDisplayTypeName(src) {
      switch (src) {
        case 1:
          return "入力";
        case 2:
          return "編集";
        case 3:
          return "削除";
      }
    },
    getDisplayPaddyFieldNames(paddyFields) {
      if (!paddyFields) {
        return "";
      }
      if (paddyFields.length < 1) {
        return "";
      }
      const tmp = [];
      paddyFields.forEach((item) => {
        if (item.paddy_field_name) {
          tmp.push(item.paddy_field_name);
        }
      });
      return tmp.join();
    },

    onClickAllItem() {
      this.workItemList = this.workItemList.concat(
        this.masterWorkProgress.slice(5)
      );
    },

    onClickWorkItem(index) {
      this.$router.push({
        name: "works-detail-edit",
        params: {
          viewMode: "e",
          season_id: this.workItemList[index].season_id,
          item_id: this.workItemList[index].item_id,
          routeName: "dashboard"
        },
      });
    },

    getWaterGateTypeName(gateType) {
      if (gateType === WATER_GATE_TYPE.SUPPLY) {
        return "給水";
      }
      else {
        return "排水";
      }
    },
    isWaterGateFull(status) {
      return status === WATER_GATE_STATUS.FULL;
    },
    isWaterGateHalf(status) {
      return status === WATER_GATE_STATUS.HALF;
    },
    getWaterGateStatusName(status) {
      if (this.isWaterGateFull(status)) {
        return "全開";
      }
      else if (this.isWaterGateHalf(status)) {
        return "半開";
      }
      else {
        return "閉門";
      }
    },

    /////////////////////////////////////////////
    // paging
    /////////////////////////////////////////////

    isInformationCurrent(pageNo) {
      return this.pagingInformation.pageNoCurrent === pageNo;
    },

    async pagingInformationsFirst() {
      await this.searchInformations(1);
    },
    async pagingInformationsPrevious() {
      if (this.pagingInformation.pageNoCurrent > 1) {
        await this.searchInformations(this.pagingInformation.pageNoCurrent - 1);
      }
    },
    async pagingInformationsNext() {
      if (
        this.pagingInformation.pageNoCurrent < this.pagingInformation.pageNoMax
      ) {
        await this.searchInformations(this.pagingInformation.pageNoCurrent + 1);
      }
    },
    async pagingInformationsLast() {
      if (
        this.pagingInformation.pageNoCurrent < this.pagingInformation.pageNoMax
      ) {
        await this.searchInformations(this.pagingInformation.pageNoMax);
      }
    },
    async pagingInformationsNo(pageNo) {
      await this.searchInformations(pageNo);
    },

    isLogCurrent(pageNo) {
      return this.pagingLog.pageNoCurrent === pageNo;
    },

    async pagingLogsFirst() {
      await this.searchLogs(1);
    },
    async pagingLogsPrevious() {
      if (this.pagingLog.pageNoCurrent > 1) {
        await this.searchLogs(this.pagingLog.pageNoCurrent - 1);
      }
    },
    async pagingLogsNext() {
      if (this.pagingLog.pageNoCurrent < this.pagingLog.pageNoMax) {
        await this.searchLogs(this.pagingLog.pageNoCurrent + 1);
      }
    },
    async pagingLogsLast() {
      if (this.pagingLog.pageNoCurrent < this.pagingLog.pageNoMax) {
        await this.searchLogs(this.pagingLog.pageNoMax);
      }
    },
    async pagingLogsNo(pageNo) {
      await this.searchLogs(pageNo);
    },
    isImages(info) {
      if (info.image_paths && info.image_paths.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    isAlertCurrent(pageNo) {
      return this.pagingAlert.pageNoCurrent === pageNo;
    },
    async pagingAlertFirst() {
      await this.searchAlert(1);
    },
    async pagingAlertPrevious() {
      if (this.pagingAlert.pageNoCurrent > 1) {
        await this.searchAlert(this.pagingAlert.pageNoCurrent - 1);
      }
    },
    async pagingAlertNext() {
      if (this.pagingAlert.pageNoCurrent < this.pagingAlert.pageNoMax) {
        await this.searchAlert(this.pagingAlert.pageNoCurrent + 1);
      }
    },
    async pagingAlertLast() {
      if (this.pagingAlert.pageNoCurrent < this.pagingAlert.pageNoMax) {
        await this.searchAlert(this.pagingAlert.pageNoMax);
      }
    },
    async pagingAlertNo(pageNo) {
      await this.searchAlert(pageNo);
    },

    isSensorCurrent(pageNo) {
      return this.pagingSensor.pageNoCurrent === pageNo;
    },
    async pagingSensorFirst() {
      await this.searchSensor(1);
    },
    async pagingSensorPrevious() {
      if (this.pagingSensor.pageNoCurrent > 1) {
        await this.searchSensor(this.pagingSensor.pageNoCurrent - 1);
      }
    },
    async pagingSensorNext() {
      if (this.pagingSensor.pageNoCurrent < this.pagingSensor.pageNoMax) {
        await this.searchSensor(this.pagingSensor.pageNoCurrent + 1);
      }
    },
    async pagingSensorLast() {
      if (this.pagingSensor.pageNoCurrent < this.pagingSensor.pageNoMax) {
        await this.searchSensor(this.pagingSensor.pageNoMax);
      }
    },
    async pagingSensorNo(pageNo) {
      await this.searchSensor(pageNo);
    },
    isWaterGateCurrent(pageNo) {
      return this.pagingWaterGate.pageNoCurrent === pageNo;
    },

    async pagingWaterGatesFirst() {
      this.loading(async () => {
        await this.searchWaterGates(1);
      });
    },
    async pagingWaterGatesPrevious() {
      if (this.pagingWaterGate.pageNoCurrent > 1) {
        this.loading(async () => {
          await this.searchWaterGates(this.pagingWaterGate.pageNoCurrent - 1);
        });
      }
    },
    async pagingWaterGatesNext() {
      if (
        this.pagingWaterGate.pageNoCurrent < this.pagingWaterGate.pageNoMax
      ) {
        this.loading(async () => {
          await this.searchWaterGates(this.pagingWaterGate.pageNoCurrent + 1);
        });
      }
    },
    async pagingWaterGatesLast() {
      if (
        this.pagingWaterGate.pageNoCurrent < this.pagingWaterGate.pageNoMax
      ) {
        this.loading(async () => {
          await this.searchWaterGates(this.pagingWaterGate.pageNoMax);
        });
      }
    },
    async pagingWaterGatesNo(pageNo) {
      this.loading(async () => {
        await this.searchWaterGates(pageNo);
      });
    },
    /////////////////////////////////////////////
    // images upload
    /////////////////////////////////////////////

    async readFile() {
      this.loading(async () => {
        const files = this.$refs.preview.files;
        for (const file of files) {
          try {
            const compFile = await Compression.getCompressImageFileAsync(file);
            const picture = await this.getBase64(compFile);
            this.fileList.push({
              fileName: file.name,
              size: compFile.size,
              type: file.type,
              data: picture,
              file: compFile,
            });
          } catch (error) {
            console.log(error);
          }
        }
        this.$refs.preview.value = "";
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    deletePreview(index) {
      this.fileList.splice(index, 1);
    },

    isAccountExpired(acinfo) {
      if (acinfo) {
        if (acinfo.admin === 1) {
          return false;
        }
        if (acinfo.display_mode) {
          if (
            acinfo.display_mode.type === 1 ||
            acinfo.display_mode.type === 3
          ) {
            return false;
          }
        }
      }
      return true;
    },


    RenderChartWater() {
      this.chartdataWater = {
        labels: [],
        datasets: [
          {
            label: "水位",
            data: [],
            // borderColor: "#CFD8DC",
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(233, 30, 99, 0.5)",
            borderColor: "rgba(233, 30, 99, 0.7)",
          },
        ],
      };
      this.optionsWater = {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: false,
          // display: true
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ cm ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                // beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
                // min: "8/3"
              },
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 30,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      };
      let max = this.sensorDatas.length;
      if (max > 7) {
        max = 7;
      }
      for (let i = max - 1; i >= 0; i--) {
        const dt = new Date(this.sensorDatas[i].datetime);
        let timeLabels = [];
        timeLabels.push(dt.getMonth() + 1 + "/" + dt.getDate());
        timeLabels.push(
          ("0" + dt.getHours()).slice(-2) +
            ":" +
            ("0" + dt.getMinutes()).slice(-2)
        );
        this.chartdataWater.labels.push(timeLabels);
        this.chartdataWater.datasets[0].data.push(
          this.sensorDatas[i].water_level
        );
      }
      this.loadedWater = true;
    },
    RenderChartWaterTemp() {
      this.chartdataWaterTemp = {
        labels: [],
        datasets: [
          {
            label: "水温",
            data: [],
            // borderColor: "#CFD8DC",
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(233, 30, 99, 0.5)",
            borderColor: "rgba(233, 30, 99, 0.7)",
          },
        ],
      };
      this.optionsWaterTemp = {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: false,
          // display: true
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ ℃ ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                // beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
                // min: "8/3"
              },
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 30,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      };
      let max = this.sensorDatas.length;
      if (max > 7) {
        max = 7;
      }

      for (let i = max - 1; i >= 0; i--) {
        const dt = new Date(this.sensorDatas[i].datetime);
        let timeLabels = [];
        timeLabels.push(dt.getMonth() + 1 + "/" + dt.getDate());
        timeLabels.push(
          ("0" + dt.getHours()).slice(-2) +
            ":" +
            ("0" + dt.getMinutes()).slice(-2)
        );
        this.chartdataWaterTemp.labels.push(timeLabels);
        this.chartdataWaterTemp.datasets[0].data.push(
          this.sensorDatas[i].water_temperature
        );
      }

      this.loadedWaterTemp = true;
    },    
  },
};
</script>

<style lang="scss">
.dashboard {
  &.frame-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  // .header {
  //   margin: 2rem;
  // }
  .list-container {
    // overflow: auto;
    width: 100%;
    // height: calc(100% - 130px);
    position: relative;
    padding: 0px 30px;
    box-sizing: border-box;
    // margin-top: 2rem;

    table {
      margin: 30px auto 30px;
      width: 100%;
      border: solid 1px #ddd;
      font-size: 0.9rem;
      background: #fff;
      // table-layout: fixed;
      /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
    }
    th {
      padding: 8px;
      border-bottom: solid 1px #bbb;
      // border-right: solid 1px #bbb;
      background: #ccc;
      font-weight: normal;

      &.list {
        border-right: solid 1px #bbb;
      }
    }

    th:nth-child(0) {
      border-right: none;
    }

    td {
      padding: 8px;
      border-bottom: solid 1px #ddd;
      // border-right: solid 1px #ddd;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.tx-datetime {
        // width: 20%;
        width: 10%;
        max-width: 100px;
      }
      &.tx-date {
        width: 5%;
        padding-right: 4px;
      }
      &.tx-name {
        // width: 20%;
        width: 10%;
        max-width: 150px;
      }
      &.tx-name-work {
        // width: 15%;
        width: 10%;
        max-width: 200px;
        padding-left: 4px;
        padding-right: 4px;
      }
      &.tx-type {
        width: 10%;
        max-width: 40px;
      }
      &.tx-paddyfield {
        // width: 30%;
        // max-width: 140px;
        max-width: 0px;
        padding-left: 4px;
        padding-right: 4px;
      }
      &.tx-content {
        width: 80%;
        max-width: 0px;
      }
      &.tx-item {
        width: 20%;
        max-width: 200px;
        padding-left: 4px;
        padding-right: 4px;
      }
      &.tx-nothing {
        width: 100%;
      }
      &.tx-area {
        // width: 15%;
        width: 10%;
        max-width: 140px;
        padding-left: 4px;
        padding-right: 4px;
      }
      &.tx-images {
        max-width: 40px;
        width: 40px;
        padding-left: 4px;
      }
      &.tx-sensor-item {
        max-width: 0px;
        padding-left: 4px;
        padding-right: 4px;
      }
      &.tx-sensor-type {
        width: 10%;
        &.warn {
          color: var(--col5);
        }
        &.caution {
          color: var(--col1);
        }
        &.err {
          color: #333;
        }
        &.normal {
          color: var(--col3);
        }
      }
      &.tx-gate-name {
        max-width: 0px;
        padding-right: 4px;
      }
      &.tx-gate-type {
        width: 5%;
        padding-right: 4px;
      }
      &.tx-gate-status {
        width: 5%;
        padding-left: 4px;
        padding-right: 4px;
        &.full-open {
          color:var(--col3);
        }
        &.half-open {
          color:var(--col5);
        }
        &.normal {
          color: var(--col3);
        }
      }
      &.tx-gate-date {
        width: 10%;
        max-width: 150px;
        padding-left: 4px;
        padding-right: 4px;
      }
      &.tx-gate-ope {
        width: 20%;
        max-width: 0px;
        padding-left: 4px;
        padding-right: 4px;
      }
      &.list {
        border-right: solid 1px #ddd;
      }
    }

    td:nth-child(0) {
      border-right: none;
    }
    .tr-datas {
      cursor: pointer;

      &.disabled {
        cursor: inherit;
        pointer-events: none;
      }
    }
    .tr-nodatas {
      cursor: default;
    }
    .stripe tr:nth-child(2n + 1) {
      background: #f7f7f7;
    }
    .stripe tr.deleted {
      color: #9a9a9a;
    }

    ul {
      display: flex;
      width: 70%;
      margin: 20px auto 0;
      list-style: none;
      padding-left: 0px;
      align-items: center;
      flex-wrap: wrap;
      font-size: 0.9rem;
      justify-content: space-around;
    }

    .pagination a {
      display: inline-block;
      font-weight: 400;
      color: var(--purple-secondary);
      height: 30px;
      width: 30px;
      line-height: 30px;
      text-align: center;
      padding-top: 0px;
      text-decoration: none;
    }

    .pagination a:hover {
      transition: 0.3s;
      background: var(--purple-secondary);
      color: var(--purple);
    }

    .first span {
      left: -9999px;
      position: absolute;
      top: -9999px;
    }
    .first a::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_arrow_left2.svg") no-repeat center
        center;
    }

    .previous span {
      left: -9999px;
      position: absolute;
      top: -9999px;
    }

    .previous a::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_arrow_left.svg") no-repeat center
        center;
    }

    .last span {
      left: -9999px;
      position: absolute;
      top: -9999px;
    }

    .last a::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_arrow_right2.svg") no-repeat center
        center;
    }

    .next span {
      left: -9999px;
      position: absolute;
      top: -9999px;
    }

    .next a::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_arrow_right3.svg") no-repeat center
        center;
    }

    .current {
      background: var(--purple-secondary);
    }
    .current a {
      color: var(--purple);
    }
  }
  .detail-list-container {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    margin: 10px auto 10px;

    table {
      width: 100%;
      // border: solid 1px #ddd;
      font-size: 0.9rem;
      background: #fff;
      // table-layout: fixed;
      /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
    }
    th {
      padding: 8px;
      border-bottom: solid 1px #bbb;
      // border-right: solid 1px #bbb;
      background: #ccc;
      font-weight: normal;
    }

    th:nth-child(0) {
      border-right: none;
    }

    td {
      padding: 8px;
      border-bottom: solid 1px #ddd;
      // border-right: solid 1px #ddd;

      &.tx-no {
        width: 10%;
        text-align: center;
      }

      &.tx-name {
        max-width: 0%;
      }
    }

    td:nth-child(0) {
      border-right: none;
    }

    .stripe tr:nth-child(2n + 1) {
      background: #f7f7f7;
    }
  }
  .detail-item-list-container {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    margin: 10px auto 10px;

    // .detail-item-field {
    //   border-bottom: solid 1px #bbb;
    // }
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    // margin: 10px auto 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  .image-area-view {
    width: 100%;

    img {
      max-width: 100%;
      margin: 10px 0px;
    }
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      // position: absolute;
      position: fixed;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;

      &.water {
        width: 60%;
        max-width: 600px;
      }
    }

    .title-area {
      width: 100%;
      // height: 80px;
      min-height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;

      .mobile & {
        height: 60px;
      }
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    #edit-area {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    #edit-area span {
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }

    #edit-area span.active {
      border-bottom: solid 4px var(--purple);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    #edit-area span.disabled {
      border-bottom: solid 4px var(--purple);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }

    #edit-area span::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 15px;
    }

    .section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        .contents-body {
          margin: 10px;

          &.scroll {
            max-height: 50vh;
            overflow-y: scroll;
          }

          span.textarea {
            white-space: pre-line;
          }

          dl.columns {
            width: 100%;
            display: grid;
            grid-template-columns: 180px 1fr;
            align-items: top;
            grid-gap: 0px 0px;
            margin: 0;
            padding: 0;
            font-size: 16px;
            color: #333;

            .mobile & {
              grid-template-columns: 1fr 1.5fr;
            }
          }

          .columns dt {
            display: block;
            text-align: right;
            width: 100%;
            margin: 0;
            padding: 16px;
          }

          .columns dd {
            display: block;
            width: 100%;
            border-left: solid 1px #ddd;
            margin: 0;
            padding: 16px;
          }

        }

        .contents-footer {
          margin: 10px;
        }

        // 行パターンを削除(バリデーションメッセージが表示される際に高さが変わり目立ってしまうため)
        // .columns dt:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }
        // .columns dd:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }

        /* フォーム */

        input[type="text"],
        input[type="date"],
        input[type="number"] {
          width: 100%;
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 16px;
          font-size: 16px;
          outline: none;
        }

        input[type="text"]:focus,
        input[type="date"]:focus,
        input[type="number"]:focus {
          background: var(--purple-tertiary);
        }

        select {
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 38px 0 16px;
          font-size: 16px;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center;
          background-size: 25px 25px;
        }

        select:focus {
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center var(--purple-tertiary);
          background-size: 25px 25px;
        }

        textarea {
          font-size: 16px;
          width: 100%;
          min-height: 200px;
          white-space: pre-wrap;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border: solid 1px var(--purple);
          padding: 10px;
          border-radius: 10px 10px 0 10px;
          font-family: inherit;
        }

        textarea:focus {
          background: var(--purple-tertiary);
        }

        input[type="radio"] {
          display: none;
        }
        input[type="radio"] + label {
          padding: 0 20px 0 0;
        }
        input[type="radio"]:disabled + label {
          color: #aaa;
        }

        input[type="radio"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
            left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="radio"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
        input[type="radio"]:disabled + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
            center left;
          background-size: 24px 24px;
          display: inline-block;
        }

        input[type="checkbox"] {
          display: none;
        }
        input[type="checkbox"] + label {
          padding: 0 20px 0 0;
        }

        input[type="checkbox"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat
            center left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="checkbox"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
      }
    }
  }
  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .right-box {
      right: 0;
      bottom: 0;
      width: 70px;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 140px);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 70px;
    }

    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 3px;
        margin-right: 3px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 3px;
        margin-right: 3px;
      }
    }

    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text.disabled {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }

  #chart-layout {
    display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    grid-template-columns: auto;
    width: 100%;
    box-sizing: border-box;
  }
  .list-area {
    height: auto;
    min-height: 180px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 0px 20px 5px rgb(0 0 0 / 0.1);
    padding: 20px;
    margin: 15px;
    box-sizing: border-box;

    .list-area-title {
      display: grid;
      grid-template-columns: 1fr 100px;
      width: 100%;
      box-sizing: border-box;

      p {
        margin: 0;
        padding: 0;
        font-size: 20px;
      }
    }
  }
  .work-progress-layout {
    display: flex;
    flex-flow: column;
    .area-value {
      text-align: center;
    }
    .progress-bar-outer {
      width: 100%;
      display: flex;
      border-radius: 30px;
      height: 10px;
      border: solid 1px #ddd;
    }
  }
  .list-message {
    text-align: center;
    cursor: pointer;

    span {
      color: var(--col3);
    }
  }

  .chart-area {
    height: auto;
    min-height: 180px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 0px 20px 5px rgb(0 0 0 / 0.1);
    padding: 20px;
    margin: 15px;
    box-sizing: border-box;
  }
  .chart-area p {
    margin: 0;
    padding: 0;
    font-size: 20px;
  }
  .ic-info {
    display: block;
  }
  .ic-info::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_info.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 10px;
  }
  .ic-done {
    display: block;
  }
  .ic-done::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_done.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 10px;
  }
  .ic-water {
    display: block;
  }
  .ic-water::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_thermometer.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 10px;
  }
  .ic-alert {
    display: block;
  }
  .ic-alert::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_notifications.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 10px;
  }
  .ic-images {
    background: url("~@/assets/icons/ic_photo.svg") no-repeat center center;
    height: 20px;
    width: 20px;
    display: block;
  }
  .ic-water-gate {
    display: block;
  }
  .ic-water-gate::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_filter_water.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 10px;
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_dashboard.svg") no-repeat center center;
  }

  #upload-area {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
  #upload-area label {
    display: block;
    font-size: 14px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
    border-bottom: solid 4px transparent;
    opacity: 0.5;
    pointer-events: none;

    > input[type="file"] {
      display: none;
    }
  }

  #upload-area label.active {
    border-bottom: solid 4px var(--purple);
    opacity: 1;
    cursor: pointer;
    pointer-events: inherit;
  }

  #upload-area label::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_upload.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }

  .upload-area-view {
    width: 100%;

    span {
      position: absolute;
    }
    span.active {
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    span::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_clear.svg") no-repeat center center;
      background-size: 30px 30px;
      padding: 0 0 0 15px;
    }

    img {
      max-width: 100%;
      margin: 10px 0px;
    }
  }
  .graph {
    display: block;
    width: 90%;
    /* padding: 10px; */
    /* height: 200px; */
    border-radius: 10px;
    background: #fff;
    margin: 20px auto 20px;
    padding: 20px;
    box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);
  }

  .graph-header {
    width: 95%;
    height: 40px;
    margin: 0 auto 0;
    padding: 0;
    display: grid;
    grid-template-columns: 30px 1fr 100px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .graph-header h5 {
    display: block;
    font-size: 16px;
    margin: 0;
    padding: 0 0 0 5px;
  }
  .graph-header span {
    display: block;
    height: 40px;
  }
  .graph-header p {
    font-size: 22px;
    font-weight: bold;
    color: #888;
    margin: 0;
    padding: 0;
    text-align: right;
  }

  .graph-graph {
    display: block;
    width: 95%;
    height: 200px;
    margin: 10px auto 0px;
    border-radius: 10px;
    background: #eee;
  }

  .water01 {
    background: url("~@/assets/icons/ic_thermometer.svg") no-repeat center
      center;
    background-size: 30px 30px;
  }

  .water02 {
    background: url("~@/assets/icons/ic_thermometer.sun.svg") no-repeat center
      center;
    background-size: 30px 30px;
  }
  .icon-water-warn {
    background: url("~@/assets/water/water02.png") no-repeat left
      center;
    background-size: 30px 30px;
  }
  .icon-water-caution {
    background: url("~@/assets/water/water03.png") no-repeat left
      center;
    background-size: 30px 30px;
  }
}
</style>
